module.exports = __webpack_public_path__ + "img/login-bg.79e2a987.png";